import React from 'react';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  makeStyles,
  Radio,
  RadioGroup
} from '@material-ui/core';

const GroupRadioForm = ({
  labels,
  selectedReason,
  setSelectedReason,
  description = 'Seleccione un motivo (requerido*):',
  disabled = false
}) => {
  const classes = useStyles();

  const handleReasonChange = event => {
    const newReason = event.target.value;
    setSelectedReason(newReason);
  };

  return (
    <FormControl
      component="fieldset"
      disabled={disabled}
      className={classes.formControl}
    >
      <FormLabel id="form-label" className={classes.mainLabel}>
        {description}
      </FormLabel>
      <RadioGroup
        aria-labelledby="form-label-radio-group"
        value={selectedReason}
        onChange={handleReasonChange}
        className={classes.radioGroup}
      >
        {Object.entries(labels || {}).map(([value, label]) => (
          <FormControlLabel
            key={value}
            value={value}
            control={<Radio color="primary" />}
            label={label}
            disabled={disabled}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

const useStyles = makeStyles(theme => ({
  mainLabel: {
    marginBottom: theme.spacing(1),
    color: `${theme.palette.text.primary} !important`
  },
  formControl: {
    fontSize: 16
  },
  radioGroup: {
    gap: theme.spacing(1)
  }
}));

export default GroupRadioForm;
